import React, { useState, useEffect } from "react";
import axios from "axios";
import JobDetailsModal from "./JobDetailsModal";

const OpenPositions = () => {
  const [positions, setPositions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedJob, setSelectedJob] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    const fetchPositions = async () => {
      try {
        setLoading(true);
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/career-jobs/get-jobs`
        );
        setPositions(response.data);
        setLoading(false);
      } catch (err) {
        console.error("Error fetching job positions:", err);
        setError("Failed to load open positions");
        setLoading(false);
      }
    };

    fetchPositions();
  }, []);

  const handleOpenModal = (job) => {
    setSelectedJob(job);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    // Clear selected job after a short delay to prevent UI flicker
    setTimeout(() => setSelectedJob(null), 300);
  };

  if (loading) {
    return (
      <div className="w-full p-6 flex justify-center">
        <p className="text-gray-600">Loading open positions...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="w-full p-6 flex justify-center">
        <p className="text-red-500">{error}</p>
      </div>
    );
  }

  return (
    <div className="w-full mx-auto px-10 bg-gray-100">
      <h2 className="text-2xl font-semibold mb-4">Open Positions</h2>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 mt-6">
        {positions.map((job) => (
          <div
            key={job._id}
            className="bg-white rounded-lg shadow-md hover:shadow-xl border border-transparent hover:border-blue-500 p-6 transform transition-all duration-300 hover:scale-[1.02]"
          >
            <h3 className="text-red-600 font-medium mb-1 text-md">
              {job.jobRole}
            </h3>
            <p className="text-md text-gray-600 mb-1">{job.type}</p>
            <p className="text-md text-gray-600 mb-4">{job.location}</p>
            <button
              className="bg-blue-500 hover:bg-blue-600 text-white py-1 px-4 rounded text-md transition"
              onClick={() => handleOpenModal(job)}
            >
              More Details
            </button>
          </div>
        ))}
      </div>

      {positions.length === 0 && (
        <div className="text-center py-6">
          <p className="text-gray-500">
            No open positions available at the moment.
          </p>
        </div>
      )}

      <JobDetailsModal
        job={selectedJob}
        isOpen={isModalOpen}
        onClose={handleCloseModal}
      />
    </div>
  );
};

export default OpenPositions;
